function ready(fn) {
	if (document.readyState !== "loading") {
		fn();
	} else {
		document.addEventListener("DOMContentLoaded", fn);
	}
}

ready(() => {

	// preview immagini nella scheda
	const gallery_preview = document.querySelector("#_gallery-preview");
	if (gallery_preview) {
		import("../../common/image_gallery.js").then((module) => {
			const MovieFreeGLightbox = module.MovieFreeGLightbox;
			const images = [];
			document.querySelectorAll("._gallery_img").forEach((el, index) => {
				images.push({ href: el.dataset.gallerySrc });
			});
			new MovieFreeGLightbox({
				elements: images,
				selector: "#_gallery-preview ._gallery_img",
			});
		});
	}

	const gallery_data = document.querySelector("#_gallery-full");
	if (gallery_data) {
		import("../../common/image_gallery.js").then((module) => {
			const MovieGLightbox = module.MovieGLightbox;
			gallery_data.addEventListener("click", (event) => {
				event.preventDefault();
				new MovieGLightbox({
					url: `/misc/immagini/${gallery_data.dataset.ct}/${gallery_data.dataset.id}/`,
				});
			});
		});
	}

	// video gallery
	const video_gallery_div = document.querySelector("#_video-gallery");
	if (video_gallery_div) {
		import("../../common/image_gallery.js").then((module) => {
			const MovieVideoGLightbox = module.MovieVideoGLightbox;
			const slides = [];
			for (const video of document.querySelectorAll("._glightbox_video")) {
				slides.push({
					content: video.parentNode.innerHTML,
					id: video.dataset.id,
					jwid: video.dataset.jw_id,
					height: "auto",
				});
			}

			const video_gallery = new MovieVideoGLightbox({
				elements: slides,
				selector: "#_video-gallery ._video_img",
			});
			const show_all_button = document.querySelector("#_video-gallery-full");
			if (show_all_button) {
				show_all_button.addEventListener("click", (event) => {
					event.preventDefault();
					video_gallery.instance.open();
				});
			}
		});
	}

	// curiosita
	const trivia_button = document.querySelector("#_view_all_trivias");
	if (trivia_button) {
		trivia_button.addEventListener("click", (event) => {
			event.preventDefault();
			document.querySelector("#_other_trivias").classList.remove("d-none");
			trivia_button.classList.add("d-none");
		});
	}

	// edizioni
	const editions_button = document.querySelector("#_view_all_editions");
	if (editions_button) {
		editions_button.addEventListener("click", (event) => {
			event.preventDefault();
			for (const el of document.querySelectorAll("._hidden_editions")) {
				el.classList.remove("d-none");
			}
			editions_button.classList.add("d-none");
		});
	}

	if (document.querySelector("#news")) {
		// Aggiornamento data articoli
		import("../../common/pubdate.js");
	}
});
